import React from "react";

export default function CampaignPreviewSkeleton() {
    return (
        <div className="container camp-skeleton-wrapper">
            <div className="row">

                {/* LEFT SECTION */}
                <div className="col-lg-8">
                    <div className="camp-skeleton-main">

                        <div className="camp-skeleton camp-skeleton-title"></div>

                        <div className="camp-skeleton camp-skeleton-image"></div>

                        <div className="camp-skeleton-thumb-row">
                            {[1, 2, 3, 4, 5].map((i) => (
                                <div key={i} className="camp-skeleton camp-skeleton-thumb"></div>
                            ))}
                        </div>

                        <div className="camp-skeleton camp-skeleton-text"></div>
                        <div className="camp-skeleton camp-skeleton-text"></div>
                        <div className="camp-skeleton camp-skeleton-text small"></div>

                        <div className="camp-skeleton-tag-row">
                            {[1, 2, 3, 4].map((i) => (
                                <div key={i} className="camp-skeleton camp-skeleton-tag"></div>
                            ))}
                        </div>

                        <div className="camp-skeleton camp-skeleton-list"></div>
                        <div className="camp-skeleton camp-skeleton-list"></div>
                        <div className="camp-skeleton camp-skeleton-list"></div>

                    </div>
                </div>

                {/* RIGHT SIDEBAR */}
                <div className="col-lg-4">
                    <div className="camp-skeleton-card">

                        <div className="camp-skeleton camp-skeleton-title"></div>

                        <div className="camp-skeleton camp-skeleton-text small"></div>
                        <div className="camp-skeleton camp-skeleton-text small"></div>

                        <div className="camp-skeleton camp-skeleton-button"></div>

                    </div>
                </div>

            </div>

            {/* UPDATES */}
            <div className="camp-skeleton-updates">
                <div className="camp-skeleton camp-skeleton-title"></div>

                {[1, 2].map((i) => (
                    <div key={i} className="camp-skeleton-update-row">
                        <div className="camp-skeleton camp-skeleton-avatar"></div>
                        <div className="flex-grow-1">
                            <div className="camp-skeleton camp-skeleton-text"></div>
                            <div className="camp-skeleton camp-skeleton-text small"></div>
                            <div className="camp-skeleton camp-skeleton-paragraph"></div>
                        </div>
                    </div>
                ))}
            </div>

            {/* ORGANIZER */}
            <div className="camp-skeleton-organizer">
                <div className="camp-skeleton camp-skeleton-title"></div>

                <div className="camp-skeleton-update-row">
                    <div className="camp-skeleton camp-skeleton-avatar"></div>
                    <div>
                        <div className="camp-skeleton camp-skeleton-text"></div>
                        <div className="camp-skeleton camp-skeleton-text small"></div>
                    </div>
                </div>
            </div>

        </div>
    );
}